import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { KnownItemTypes } from 'owa-calendar-surface-dategrid';

const selectionItemId = 'schedulingSelection';
const attendeeItem = 'attendeeItem_';

/**
 * Converts a Calendar Event into a Scheduling Selection Item
 * @param start the start of item
 * @param end the end of item
 * @param isAllDay whether item is all day event or not
 */
export default function convertToCalendarEvent(
    event: Partial<CalendarEvent>,
    itemType: KnownItemTypes
): CalendarEvent {
    let id;

    if (itemType == KnownItemTypes.suggestedItems) {
        id = selectionItemId;
    } else {
        id = attendeeItem + event.Start.getTime().toString();
    }

    return {
        ...event,
        ...{
            ItemId: { Id: id },
        },
    } as CalendarEvent;
}

export function isSchedulingSelectionItem(model: CalendarEvent) {
    return model.ItemId.Id == selectionItemId;
}

export function isAttandeeItem(model: CalendarEvent) {
    return model.ItemId.Id.substr(0, attendeeItem.length) == attendeeItem;
}
